import React from 'react';
import Layout from 'components/Layout';
import HeadContent from 'components/HeadContent';
import { stringify } from 'qs';

import { loadSearchView } from 'actions/search';

import { MARKETING_NUMBER_OF_RECIPES } from 'constants/index';

const makeTitlePart = (query, key, label) =>
  query[key]?.length ? `${label}: ${query[key].slice(0, 3).join(',')}` : '';

function action({ query, path, store }) {
  const searchTerm = query.q;
  const queryParams = stringify({ q: `${searchTerm}` }, { encodedValuesOnly: true });
  const url = `${path}?${queryParams}`;

  const titleParts = [];
  if (searchTerm) {
    titleParts.push(`Search ckbk for ${searchTerm}`);
  } else {
    titleParts.push('Search ckbk for recipes');
  }
  titleParts.push(makeTitlePart(query, 'country', 'Country'));
  titleParts.push(makeTitlePart(query, 'course', 'Course'));
  titleParts.push(makeTitlePart(query, 'diet_type', 'Diet'));
  titleParts.push(makeTitlePart(query, 'skill', 'Difficulty'));
  titleParts.push(makeTitlePart(query, 'era', 'Era'));

  if (query.book_title?.length > 0) {
    titleParts.push(makeTitlePart(query, 'book_title', 'Book'));
  } else if (query.book_full_title?.length > 0) {
    titleParts.push(makeTitlePart(query, 'book_full_title', 'Book'));
  }
  titleParts.push(makeTitlePart(query, 'authors', 'Author'));

  const filteredTitleParts = titleParts.filter(t => !!t);
  let title = filteredTitleParts.join('; ');

  // Special case single author or single book
  if (filteredTitleParts.length === 2) {
    if (query.book_title?.length === 1) {
      filteredTitleParts[1] = `from ${query.book_title[0]}`;
    } else if (query.book_full_title?.length === 1) {
      filteredTitleParts[1] = `from ${query.book_full_title[0]}`;
    } else if (query.authors?.length === 1) {
      filteredTitleParts[1] = `by ${query.authors[0]}`;
    }
    title = filteredTitleParts.join(' ');
  }

  // Will cause Lazy-loading search views to be loaded straight away
  store.dispatch(loadSearchView());
  return {
    chunks: ['search', 'search-results'],
    navigation: {
      heading: 'Search',
      section: 'Search',
      left: 'backIfReferred',
    },
    component: (
      <Layout type="wide" withLeaderboardAd={false} withFooterLeaderboardAd={false}>
        <HeadContent
          contents={{
            title,
            url,
            description: `Search ckbk's collection, with advanced search filters to guide you to the most relevant results from more than ${MARKETING_NUMBER_OF_RECIPES} cookbook recipes.`,
          }}
        />
      </Layout>
    ),
  };
}

export default action;
